<script>
/**
 * Management of project milestones in a project (LOCAL CONTEXT)
 */
import ProjectMilestoneService from "@/services/ProjectMilestoneService";
import ProjectService from "@/services/ProjectService";
import Cloner from "@/libraries/Cloner";
import VoucherService from "@/services/VoucherService";
import VVoucherDetailsModal from "@/components/Costs/VVoucherDetailsModal";
import VAllocateModal from "@/components/Costs/VAllocateModal";
import VPdfModal from "@/components/Costs/VPdfModal";
import Messages from "@/mixins/Messages";
import VFilters from "@/components/Search/VFilters";
import { VoucherStatus } from "@/constants/Voucher.const";
import VEcConnection from "@/components/Costs/VEcConnection";
import VVat from "@/components/Costs/VVat";

export default {
    name: "",
    mixins: [Messages],
    components: {
        VVoucherDetailsModal,
        VAllocateModal,
        VPdfModal,
        VFilters,
        VEcConnection,
        VVat
    },
    data() {
        return {
            loading: true,
            vouchers: [],
            meta: {},
            showVoucherDetailsModal: false,
            voucherContext: null,
            showAllocateModal: false,
            allocateContext: null,
            project: {},
            showDocModal: false,
            docContext: null,
            allocateProjectId: null,
            allocateProject: null,
            bookLoading: 0
        };
    },
    computed: {
        voucherStatuses() {
            let v = VoucherStatus;
            delete v[10];
            return v;
        }
    },
    async created() {
        this.initSearch();
        await this.fetchData();
        this.loading = false;
        this.$apiEnableWatcher();
    },
    methods: {
        async fetchData() {
            try {
                let params = this.$buildParams();
                params["functionView"] = "inbox";
                params["includes"] = "project";
                const { data } = await VoucherService.GET(params);
                this.vouchers = data.data;
                this.meta = data.meta;
            } catch (e) {
                console.log("fd e", e);
            }
        },
        /**
         * Ignore a given voucher
         * @param voucher_id
         */
        async ignoreVoucher(voucher_id) {
            this.$swal({
                icon: "warning",
                text: this.$t("vouchers.swal_confirm_ignore_voucher"),
                showConfirmButton: true,
                showCancelButton: true
            }).then(async confirmed => {
                if (confirmed.isConfirmed) {
                    await VoucherService.PUT_ignore(voucher_id);
                    this.fetchData();
                    this.$msgSuccess(
                        this.$t("vouchers.notify_voucher_ignored")
                    );
                }
            });
        },
        /**
         * Un-ignore a voucher
         * @param voucher_id
         */
        async unIgnoreVoucher(voucher_id) {
            this.$swal({
                icon: "warning",
                text: this.$t("vouchers.swal_confirm_unignore_voucher"),
                showConfirmButton: true,
                showCancelButton: true
            }).then(async confirmed => {
                if (confirmed.isConfirmed) {
                    await VoucherService.PUT_unignore(voucher_id);
                    this.fetchData();
                    this.$msgSuccess(
                        this.$t("vouchers.notify_voucher_unignored")
                    );
                }
            });
        },
        /**
         * Fetch the project + customer
         */
        async fetchProject() {
            try {
                const r = await ProjectService.GETS(this.allocateProjectId);
                this.allocateProject = r.data.data;
            } catch (e) {
                console.log("fetchProject exception", e);
            }
        },
        showVoucherDetails(ctx) {
            this.voucherContext = ctx;
            this.showVoucherDetailsModal = true;
        },
        closeReloadVouchers() {
            this.showVoucherDetailsModal = false;
            this.fetchData();
            this.$notify({
                message: this.$t("vouchers.notify_entry_amount_updated"),
                timeout: 5000,
                icon: "far fa-check",
                type: "success"
            });
        },
        /**
         * Close allocate & reload
         */
        closeReload() {
            this.showAllocateModal = false;
            this.fetchData();
            this.$notify({
                message: this.$t("vouchers.notify_new_entry_created"),
                timeout: 5000,
                icon: "far fa-check",
                type: "success"
            });
        },
        async showAllocate(ctx) {
            this.bookLoading = ctx.project_id;
            try {
                this.allocateProjectId = ctx.project_id;
                await this.fetchProject();
            } catch (e) {
                console.log("alloc e", e);
            }

            this.allocateContext = ctx;
            this.showAllocateModal = true;
            this.bookLoading = 0;
        },
        showVoucherDoc(v) {
            this.showDocModal = true;
            this.docContext = v;
        },
        initSearch() {
            this.apiSearchFilter = {
                search: "",
                status: "1",
                ec_voucher_number: ""
            };
        }
    }
};
</script>

<template>
    <div>
        <base-header class="pb-1" type="">
            <bread-bag>
                <base-button
                    type="secondary"
                    size="sm"
                    @click="setContext({ empty: true })"
                    >{{ $t("travel_prices.add_new") }}</base-button
                >
            </bread-bag>
        </base-header>
        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <v-filters
                        :enable-filters="true"
                        v-model="apiSearchFilter.search"
                        :search="true"
                        start-open
                        :search-placeholder="
                            $t('vouchers.placeholder_search_in_vouchers')
                        "
                        @reset-search="initSearch"
                    >
                        <template slot="default">
                            <div class="col-lg-3 col-md-12">
                                <FormulateInput
                                    v-model="apiSearchFilter.status"
                                    :placeholder="
                                        $t('form_elems.voucher_status')
                                    "
                                    type="multiselect"
                                    :multiple="false"
                                    :options="voucherStatuses"
                                />
                            </div>
                            <div class="col-lg-3 col-md-12">
                                <FormulateInput
                                    v-model="apiSearchFilter.ec_voucher_number"
                                    type="text"
                                    :placeholder="
                                        $t('form_elems.ec_voucher_number')
                                    "
                                />
                            </div>
                        </template>
                    </v-filters>

                    <card body-classes="px-0">
                        <v-loader :loading="loading" v-if="loading" />
                        <template v-else-if="vouchers.length > 0">
                            <v-table
                                class="table table-mg table-sm costs-inbox"
                            >
                                <v-thead>
                                    <v-tr>
                                        <v-th
                                            ><v-sorter
                                                :paginator="apiPaginator"
                                                @sort="$handleSorting($event)"
                                                name="created"
                                                >{{
                                                    $t(
                                                        "vouchers.tbl_hdr_imported"
                                                    )
                                                }}</v-sorter
                                            ></v-th
                                        >
                                        <v-th
                                            ><v-sorter
                                                :paginator="apiPaginator"
                                                @sort="$handleSorting($event)"
                                                name="Projects.title"
                                                >{{
                                                    $t(
                                                        "vouchers.tbl_hdr_project"
                                                    )
                                                }}</v-sorter
                                            ></v-th
                                        >

                                        <v-th
                                            ><v-sorter
                                                :paginator="apiPaginator"
                                                @sort="$handleSorting($event)"
                                                name="ec_voucher_number"
                                                >{{
                                                    $t(
                                                        "vouchers.tbl_hdr_voucher_nr"
                                                    )
                                                }}</v-sorter
                                            ></v-th
                                        >
                                        <v-th
                                            ><v-sorter
                                                :paginator="apiPaginator"
                                                @sort="$handleSorting($event)"
                                                name="voucher_date"
                                                >{{
                                                    $t("vouchers.tbl_hdr_date")
                                                }}</v-sorter
                                            ></v-th
                                        >
                                        <v-th
                                            ><v-sorter
                                                :paginator="apiPaginator"
                                                @sort="$handleSorting($event)"
                                                name="description"
                                                >{{
                                                    $t(
                                                        "vouchers.tbl_hdr_description"
                                                    )
                                                }}</v-sorter
                                            ></v-th
                                        >
                                        <v-th class="text-right"
                                            ><v-sorter
                                                :paginator="apiPaginator"
                                                @sort="$handleSorting($event)"
                                                name="amount"
                                                >{{
                                                    $t(
                                                        "vouchers.tbl_hdr_amount"
                                                    )
                                                }}</v-sorter
                                            ></v-th
                                        >
                                        <v-th></v-th>
                                    </v-tr>
                                </v-thead>
                                <v-tbody>
                                    <v-tr
                                        v-for="v in vouchers"
                                        :key="v.id"
                                        :class="{ 'is-bounced': v.is_bounced }"
                                    >
                                        <v-td
                                            >{{
                                                $d(new Date(v.created), "short")
                                            }}
                                            <div class="small text-muted">
                                                {{ voucherStatuses[v.status] }}
                                            </div>
                                            <div
                                                class="mt-2"
                                                style=""
                                                v-if="v.is_bounced"
                                            >
                                                <i
                                                    class="far fa-exclamation-triangle"
                                                ></i>
                                                {{
                                                    $t(
                                                        "vouchers.warn_bounced_back"
                                                    )
                                                }}
                                            </div>
                                            <div
                                                class="small text-muted"
                                                v-if="true"
                                            >
                                                <i
                                                    class="far fa-fingerprint"
                                                ></i>
                                                {{ v.id }}
                                            </div>
                                        </v-td>
                                        <v-td>
                                            <router-link
                                                :to="{
                                                    name:
                                                        'ProjectViewCostsInbox',
                                                    params: {
                                                        project_id: v.project_id
                                                    }
                                                }"
                                                >{{
                                                    v.project.title
                                                }}</router-link
                                            >
                                            <div class="small text-muted">
                                                <v-ec-connection :context="v" />
                                            </div>
                                        </v-td>

                                        <v-td>{{ v.ec_voucher_number }}</v-td>
                                        <v-td>{{
                                            $d(
                                                new Date(v.voucher_date),
                                                "short"
                                            )
                                        }}</v-td>
                                        <v-td
                                            >{{ v.description }}
                                            <i
                                                @click="showVoucherDetails(v)"
                                                class="far m-click text-muted fa-info-square fa-fw fa-lg"
                                            ></i>
                                            <div
                                                v-if="
                                                    parseInt(
                                                        v.matched_milestone
                                                    ) > 0
                                                "
                                                class="text-bold text-info"
                                            >
                                                <hr
                                                    style="padding: 0px; margin-top: 10px; margin-bottom: 10px;"
                                                />
                                                <i
                                                    class="fas fa-head-side-brain"
                                                ></i>
                                                {{
                                                    $t(
                                                        "vouchers.recommended_milestone"
                                                    )
                                                }}:
                                                <span class="text-warning"
                                                    >M{{
                                                        v.matched_milestone
                                                    }}</span
                                                >
                                            </div>
                                        </v-td>
                                        <v-td class="text-right"
                                            >{{
                                                $n(v.amount, {
                                                    style: "currency",
                                                    currency: v.currency,
                                                    currencyDisplay: "code"
                                                })
                                            }}
                                            <v-vat :vat="v.has_vat" />

                                            <div
                                                class="text-warning"
                                                v-if="v.amount < 0"
                                            >
                                                <i
                                                    class="far fa-exclamation-triangle"
                                                ></i>
                                                {{
                                                    $t(
                                                        "vouchers.note_neg_amount_"
                                                    )
                                                }}
                                            </div>
                                        </v-td>

                                        <v-td style="width: 180px">
                                            <base-button
                                                v-if="v.status == 1"
                                                size="sm"
                                                type="primary"
                                                @click="showAllocate(v)"
                                                :loading="
                                                    bookLoading == v.project_id
                                                "
                                                block
                                            >
                                                <i
                                                    class="far fa-book-open fa-fw mr-1"
                                                ></i>
                                                {{
                                                    $t(
                                                        "vouchers.action_allocate"
                                                    )
                                                }}
                                            </base-button>
                                            <base-button
                                                size="sm"
                                                type="info"
                                                outline
                                                @click="showVoucherDoc(v)"
                                                :disabled="!v.has_doc"
                                                block
                                            >
                                                <i
                                                    class="far fa-file-pdf fa-fw mr-1"
                                                ></i>
                                                {{
                                                    $t(
                                                        "vouchers.action_show_pdf"
                                                    )
                                                }}
                                            </base-button>
                                            <base-button
                                                v-if="v.status == 1"
                                                size="sm"
                                                type="warning"
                                                outline
                                                block
                                                @click="ignoreVoucher(v.id)"
                                            >
                                                <i
                                                    class="far fa-times-square fa-fw mr-1"
                                                ></i>
                                                {{
                                                    $t("vouchers.action_ignore")
                                                }}</base-button
                                            >
                                            <base-button
                                                v-else
                                                size="sm"
                                                type="success"
                                                outline
                                                block
                                                @click="unIgnoreVoucher(v.id)"
                                            >
                                                <i
                                                    class="far fa-undo fa-fw mr-1"
                                                ></i>
                                                {{
                                                    $t(
                                                        "vouchers.action_unignore"
                                                    )
                                                }}</base-button
                                            >
                                        </v-td>
                                    </v-tr>
                                </v-tbody>
                            </v-table>
                            <div class="paginator">
                                <base-pagination
                                    :page-count="meta.pagination.total_pages"
                                    :per-page="meta.pagination.per_page"
                                    :value="meta.pagination.current_page"
                                    @input="$handlePagination($event)"
                                />
                            </div>
                        </template>
                        <div class="alert alert-warning mx-4" v-else>
                            {{ $t("vouchers.no_vouchers_found") }}
                        </div>
                    </card>
                </div>
            </div>
            <portal to="modals">
                <v-allocate-modal
                    :context="allocateContext"
                    :project-id="allocateProjectId"
                    :project="allocateProject"
                    v-if="showAllocateModal"
                    @close="showAllocateModal = false"
                    @close-reload="closeReload"
                />
                <v-voucher-details-modal
                    v-if="showVoucherDetailsModal"
                    @close="showVoucherDetailsModal = false"
                    @close-reload="closeReloadVouchers"
                    :context="voucherContext"
                />
                <v-pdf-modal
                    v-if="showDocModal"
                    :context="docContext"
                    @close="showDocModal = false"
                />
            </portal>
        </div>
    </div>
</template>

<style lang="scss">
.costs-inbox {
    .is-bounced {
        td {
            color: $danger;
        }
    }
}
</style>
